import { render, staticRenderFns } from "./AssignClient.vue?vue&type=template&id=432ae8ca&"
import script from "./AssignClient.vue?vue&type=script&lang=js&"
export * from "./AssignClient.vue?vue&type=script&lang=js&"
import style0 from "./AssignClient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('432ae8ca', component.options)
    } else {
      api.reload('432ae8ca', component.options)
    }
    module.hot.accept("./AssignClient.vue?vue&type=template&id=432ae8ca&", function () {
      api.rerender('432ae8ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AssignClient.vue"
export default component.exports